import {stores,runInAction} from 'mutants-microfx';
import {toJS} from 'mobx';
const user = stores.user;
export default function(mergeData){
    let userOptions = toJS(user.options);
    runInAction(()=>{
        let newData = {...userOptions.loginInfo,...mergeData};
        user.options.set('loginInfo',newData);
    });
}
